<div>
	<div class="header">
		<h2 class="icon">{{ 'REALTIME_TOP_CLIPS' | translate | uppercase }}</h2>
		<div [hasPermission]="'root'">
			<label>Update interval ({{updateInterval}}s)
				<input [(ngModel)]="updateInterval" min="1" type="number" />
			</label>
		</div>
	</div>
	<ul>
		<li *ngFor="let item of toplistOutput" class="overflow">
			<div class="icon clickable"><a [routerLink]="['/analytics/statistics', item.id]"><i class="fa fa-line-chart" title="{{ 'STATISTICS' | translate }}" aria-hidden="true"></i></a></div>
			<div class="text">{{ item.title || item.id }}</div>
			<div class="count">{{ item.count }}</div>
			<hr [ngStyle]='{ background: item.style }'>
		</li>
	</ul>

	<div class="header">
		<h2 class="icon">{{ 'DOMAINS' | translate | uppercase }}</h2>
	</div>
	<ul>
		<li *ngFor="let item of referrersOutput; let i = index" class="overflow" (click)="openSubitems($event, item.title)" class="domain">
			<div class="icon bold">{{ domainShown === item.title ? '-' : '+' }}</div>
			<div class="text">{{ item.title }}</div>
			<div class="count">{{ item.count }}</div>
			<hr [ngStyle]='{ background: item.style }'>
			<ul *ngIf="domainShown === item.title">
				<li *ngFor="let subItem of item.items" class="overflow">
					<a target="_blank" [href]="subItem.url" (click)="$event.stopPropagation()">
						<div class="icon">&nbsp;</div>
						<div class="text subItem">{{ subItem.title }}</div>
						<div class="count">{{ subItem.count }}</div>
						<hr [ngStyle]='{ background: subItem.style }'>
					</a>
				</li>
			</ul>
		</li>
	</ul>

	<div class="header">
		<h2 class="icon">{{ 'OPERATING_SYSTEMS' | translate | uppercase }}</h2>
	</div>
	<ul>
		<li *ngFor="let item of devicesOutput" class="overflow">
			<div class="icon" [innerHTML]="item.deviceInfo | deviceInfo"></div>
			<div class="text">{{ item.title }}</div>
			<div class="count">{{ item.count }}</div>
			<hr [ngStyle]='{ background: item.style }'>
		</li>
	</ul>

</div>
